<template>
  <div class="form w-1/2">
    <Loading
      v-if="loadingSaveData"
      class="mb-2"
    />

    <BaseInput
      id="article"
      :label="$t('main.article')"
      v-model="form.article"
      :errors="errorsFor('article')"
      :hintInput="$t('admin.views.materials.auto') + ' ' + type.data.attributes.article_template + ' XXXX'"
    />

    <div class="form-group">
      <div class="flex items-center gap-8">
        <button
          class="rounded flex justify-center items-center main-check focus:outline-none"
          type="button"
          @click="form.status = form.status == 1 ? 0 : 1"
        >
          <span class="check"><i
              v-if="form.status==1"
              class="fas fa-check text-red-500"
            ></i></span>
          <span class="ml-2 text-sm">{{$t('main.published')}}</span>
        </button>

        <button
          class="rounded flex justify-center items-center main-check focus:outline-none"
          type="button"
          @click="form.main = form.main == 1 ? 0 : 1"
        >
          <span class="check"><i
              v-if="form.main==1"
              class="fas fa-check text-red-500"
            ></i></span>
          <span class="ml-2 text-sm">{{$t('admin.views.materials.material_main_group')}}</span>
        </button>

      </div>
      <ValidationErrors :errors="errorsFor('main')" />
    </div>

    <BaseInput
      id="name"
      :label="$t('main.label_name')"
      v-model="form.name"
      :required="true"
      :errors="errorsFor('name')"
    />

    <div class="form-group">
      <label for="type_id">{{$t('main.type')}}</label>
      <div class="flex items-center">
        <select
          id="type_id"
          v-model="form.type_id"
        >
          <option :value="null">{{$t('admin.views.materials.type_material_not_selected')}}</option>
          <option
            v-for="type in types"
            :key="type.data.type_id"
            :value="type.data.type_id"
          >
            {{ type.data.attributes.name }}
          </option>
        </select>
      </div>
      <ValidationErrors :errors="errorsFor('type_id')" />
    </div>

    <BaseInput
      id="cost_coefficient"
      :label="$t('admin.views.materials.coef_price')"
      v-model="form.cost_coefficient"
      :errors="errorsFor('cost_coefficient')"
      :hint="$t('admin.views.materials.coef_price')"
    />

    <BaseInput
      id="price"
      type="number"
      :label="$t('admin.views.materials.coef_cub_price')"
      :placeholder="'0.00'"
      v-model="form.price"
      :errors="errorsFor('price')"
    />
    <BaseInput
      id="cost"
      type="number"
      :isCost="true"
      :label="$t('main.label_cost_price')"
      :placeholder="'0.00'"
      v-model="form.cost"
      :errors="errorsFor('cost')"
    />

    <div class="form-group">
      <div class="flex items-center">
        <label for="image">{{$t('admin.views.materials.image_texture')}}:
        </label>
      </div>

      <FileInputBlock
        :prefill="imagePreview"
        :selectedImageFileNameDefault="$t('main.image_texture_not_selected')"
        :alreadyLoadText="$t('main.image_texture_selected')"
        :loadedFile="this.material&&this.material.data.attributes.image"
        @selected-file="(file) => selectFile(file, 'Image')"
        @remove-file="removeFile('Image')"
      >
        <ValidationErrors :errors="errorsFor('image')" />
      </FileInputBlock>

    </div>

    <div class="form-group">
      <button
        @click="saveData"
        type="button"
        class="btn btn-small btn-green"
      >
        {{ $t('main.button_save') }}
      </button>
      <router-link
        :to="{ name: 'materials' }"
        class="ml-2 btn btn-small btn-default"
      >{{ $t('main.button_cancel') }}</router-link>
    </div>
  </div>
</template>

<script>
import validationErrors from "../../../mixins/validationErrors";
const defaultTexturePreview = "/images/design/zaglushka-textura.svg";

export default {
  name: "Form",
  mixins: [validationErrors],
  props: {
    material: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      imagePreview: this.material
        ? this.material.data.attributes.image || defaultTexturePreview
        : defaultTexturePreview,
      loadingSaveData: false,
      form: {
        article: this.material ? this.material.data.attributes.article : null,
        main: this.material ? this.material.data.attributes.main : 0,
        status: this.material ? this.material.data.attributes.status : 1,
        name: this.material ? this.material.data.attributes.name : null,
        type_id:
          this.material && this.material.data.attributes.type
            ? this.material.data.attributes.type.type_id
            : null,
        cost_coefficient: this.material
          ? this.material.data.attributes.cost_coefficient
          : null,
        price: this.material ? this.material.data.attributes.price : null,
        cost: this.material ? this.material.data.attributes.cost : null,
        selectedImage: null,
        removeImage: null,
      },
      type: {
        data: {
          attributes: {
            article_template:
              this.material && this.material.data.attributes.type
                ? this.material.data.attributes.type.article_template
                : "XX-",
          },
        },
      },
    };
  },
  computed: {
    types() {
      return this.$store.state.materials.types;
    },
  },
  methods: {
    selectFile(file, dataProps) {
      this.form[`selected${dataProps}`] = file;
      this.form[`remove${dataProps}`] = false;
    },
    removeFile(dataProps) {
      this.form[`selected${dataProps}`] = null;
      this.form[`remove${dataProps}`] = true;
    },
    async saveData() {
      this.errors = null;
      this.loadingSaveData = true;

      try {
        let formDataPost = new FormData();

        if (this.material) formDataPost.append("_method", "PATCH");

        if (this.form.name !== null) {
          formDataPost.append("name", this.form.name);
        }

        if (this.form.article !== null) {
          formDataPost.append("article", this.form.article);
        }

        if (this.form.main !== null) {
          formDataPost.append("main", this.form.main);
        }

        if (this.form.status !== null) {
          formDataPost.append("status", parseInt(this.form.status));
        }

        if (this.form.type_id !== null) {
          formDataPost.append("type_id", this.form.type_id);
        }

        if (this.form.cost_coefficient !== null) {
          formDataPost.append("cost_coefficient", this.form.cost_coefficient);
        }

        if (this.form.price !== null) {
          formDataPost.append("price", this.form.price);
        }

        if (this.form.cost !== null) {
          formDataPost.append("cost", this.form.cost);
        }

        if (this.form.selectedImage !== null) {
          formDataPost.append("image", this.form.selectedImage);
        }

        if (this.form.removeImage) {
          formDataPost.append("remove_image", this.form.removeImage);
        }

        let url = "/api/admin/materials";
        if (this.material)
          url = `/api/admin/materials/${this.material.data.material_id}`;

        const res = (
          await axios.post(url, formDataPost, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
        ).data;
        const materialId = res?.data?.material?.data?.material_id;
        if (!materialId) {
          throw new Error("Некорректный ответ сервера");
        }

        if (!this.material) {
          await this.$router
            .replace({
              name: "edit_material",
              params: { material_id: materialId },
              query: this.$route.query,
            })
            .catch((e) => {});
        }
      } catch (error) {
        this.errors = error?.response?.data?.errors || null;
        this.status = error?.response?.status || null;
        const notification = {
          type: "error",
          message:
            error?.response?.data?.message ||
            error?.message ||
            "Ошибка при сохранении",
        };
        this.$store.dispatch("notification/add", notification, {
          root: true,
        });
      }
      this.loadingSaveData = false;
    },
  },
};
</script>
